<template>
  <!-- 搜尋區塊 -->
  <div class="Search_Bar" style="z-index:1000000000000">
    <div class="Search_Bar_item">
      <ul class="search-navtabs">
        <li
          @click="
            reselected();
            checkdevice();
            isShowEduSelection = !isShowEduSelection;
            isShowSubjectSelection = false;
            isShowAreaSelection = false;
            isShowSDGsSelection = false,

            selectedResultShow = false;

          "
        >
          <i class="icon-search-01"></i>
          <span v-if="selectedLevel == ''">學習階段</span>
          <span v-else>{{ selectedLevel }}</span>
        </li>

        <li
          @click="
            reselected();
            checkdevice();
            isShowSubjectSelection = !isShowSubjectSelection;
            isShowEduSelection = false;
            isShowAreaSelection = false;
            isShowSDGsSelection = false,

            selectedResultShow = false;
          "
        >
          <i class="icon-search-02"></i>
          <span v-if="selectedSubject == ''">學習科目</span>
          <span v-else>{{ selectedSubject }}</span>
        </li>

        <!-- 新增的 SDGs 按鈕 -->
        <li
          @click="
            reselected();
            checkdevice();
            isShowSDGsSelection = !isShowSDGsSelection;
            isShowEduSelection = false;
            isShowSubjectSelection = false;
            isShowAreaSelection = false;
            selectedResultShow = false;
          "
        >
          <i class="icon-search-04"></i>
          <span v-if="selectedSDG == ''">SDGs</span>
          <span v-else>{{ selectedSDG.split(' ')[0] }}</span>
        </li>

        <li
          @click="
            reselected();
            checkdevice();
            isShowAreaSelection = !isShowAreaSelection;
            isShowEduSelection = false;
            isShowSubjectSelection = false;
            isShowSDGsSelection = false,
            selectedResultShow = false;
          "
        >
          <i class="icon-search-03"></i>
          <span v-if="selectedArea == ''">學習地區</span>
          <span v-else>{{ selectedArea }}</span>
        </li>
      </ul>

      <div class="search-container">
        <input
          v-model="searchKeyWord"
          placeholder="關鍵字搜尋..."
          name="search"
          @keyup.enter="
            filterPlansComputed(
              selectedLevel,
              selectedSubject,
              selectedSDG,
              selectedArea,
              searchKeyWord
            );
            isShowEduSelection = false;
            isShowSubjectSelection = false;
            isShowAreaSelection = false;
            isShowSDGsSelection = false"
        />
        <button
          @click="
            filterPlansComputed(
              selectedLevel,
              selectedSubject,
              selectedSDG,
              selectedArea,
              searchKeyWord
            );
            isShowEduSelection = false;
            isShowSubjectSelection = false;
            isShowAreaSelection = false;
            isShowSDGsSelection = false,

            checkdevice();
          "
        >
          搜 尋
        </button>
      </div>
      <!--      搜尋選單-->
      <div style="z-index:1000000">
        <div class="search_datawrap">
          <div
            class="search_info"
            v-if="isShowEduSelection"
            style="z-index:10000000; position: sticky; background-color: #fff ; border-radius:10px"
          >
            <button
              v-for="edu in edusData.eduLevels"
              :key="edu"
              @click="
                selectedLevel = edu;
                isShowEduSelection = !isShowEduSelection;
                selectedSubject = '';
                selectedArea = '';
                selectedSDG = '';
              "
            >
              {{ edu }}
            </button>
          </div>
        </div>
        <div class="search_datawrap">
          <div
            class="search_info"
            v-if="isShowSubjectSelection"
            style="z-index:10000000; position: sticky; background-color: #fff;border-radius:10px"
          >
            <p v-if="selectedLevel == ''">請先選擇學習階段</p>

            <button
              v-if="selectedLevel !== ''"
              @click="
                selectedSubject = '全部科目';
                isShowSubjectSelection = !isShowSubjectSelection;
              "
            >
              全部科目
            </button>
            <button
              v-for="sub in subjectsByLevels(selectedLevel)"
              :key="sub"
              @click="
                selectedSubject = sub;
                isShowSubjectSelection = !isShowSubjectSelection;
              "
            >
              {{ sub }}
            </button>
          </div>
        </div>

        <div class="search_datawrap">
          <div
            class="search_info"
            v-if="isShowSDGsSelection"
            style="z-index:10000000; position: sticky; background-color: #fff;border-radius:10px"
          >
            <div>
              <button
              @click="
                selectedSDG = '全部目標';
                isShowSDGsSelection = !isShowSDGsSelection;
              "
            >
              全部目標
            </button>
              <button
                v-for="sdg in sdgsData.sdgs"
                :key="sdg"
                @click="
                  // selectedSDG = sdg.split(' ')[0];
                  selectedSDG = sdg;
                  isShowSDGsSelection = !isShowSDGsSelection;
                "
              >
                {{ sdg }}
              </button>
            </div>
          </div>
        </div>

        <div class="search_datawrap">
          <div
            class="search_info"
            v-if="isShowAreaSelection"
            style="z-index:10000000; position: sticky; background-color: #fff;border-radius:10px"
          >
            <div>
              <button
                @click="
                  selectedArea = '全臺';
                  isShowAreaSelection = !isShowAreaSelection;
                "
              >
                全臺
              </button>
              <button
                v-for="area in areasData.areas"
                :value="area"
                :key="area"
                @click="
                  selectedArea = area;
                  isShowAreaSelection = !isShowAreaSelection;
                "
              >
                {{ area }}
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!--  搜尋結果 & 敬請期待-->
      <div class="search_datawrap " style="z-index:10000000">
        <!-- <div
          class="search_info"
          v-if="isShowSDGsSelection"
          style="z-index:10000000; position: sticky; background-color: #fff;border-radius:10px"
        >
          <p>敬請期待</p>
        </div> -->
        <div class="search_info" v-if="plansData.selectedResultShow">
          <p>
            搜尋結果 :

            <span v-if="plansData.afterEdu != ''">
              {{ plansData.afterEdu }}
            </span>
            <span
              v-if="plansData.afterEdu != '' && plansData.afterSubject != ''"
            >
              >
            </span>
            <span v-if="plansData.afterSubject != ''">
              {{ plansData.afterSubject }}
            </span>
            <span
              v-if="
                (plansData.afterEdu != '' || plansData.afterSubject != '')&& plansData.afterSDG != ''
              "
            >
              >
            </span>
            <span v-if="plansData.afterSDG != ''">
              {{ plansData.afterSDG }}
            </span>
            <span
              v-if="
                (plansData.afterEdu != '' || 
                plansData.afterSubject != ''|| 
                plansData.afterSDG !=='') &&
                plansData.afterArea != ''
              "
            >
              >
            </span>
            <span v-if="plansData.afterArea != ''">
              {{ plansData.afterArea }}
            </span>
            <span
              v-if="
                (plansData.afterEdu != '' ||
                  plansData.afterSubject !== '' ||
                  plansData.afterSDG !== '' ||
                  plansData.afterArea !== '') &&
                  plansData.afterSearchKey !== ''
              "
            >
              >
            </span>
            <span v-if="plansData.afterSearchKey != ''">
              {{ plansData.afterSearchKey }}
            </span>
            <span style="margin:0 auto">
              共 {{ plansData.filteredPlans.length }} 筆
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useJsonData } from "@/composable/dataProvider";
import { useSelectedData } from "@/composable/selectedData";

import { useDataContext } from "@/composable/plans";

export default {
  name: "SearchComponent",
data(){
  return {
    isShowEduSelection:false,
    isShowSubjectSelection:false,
    isShowAreaSelection:false,
    isNeedToPushDown:false,
    resultHeight:0,
    isShowSDGsSelection:false,
  }
},
  computed: {
    test() {
      return this.selectedLevel;
    },
  },
  methods: {
    scrollingUp() {
      if (document.body.clientWidth < 1024) {
        window.scrollTo({ top: 200, behavior: "smooth" });
      }
    },
    checkdevice() {
      this.isNeedToPushDown = false;

      if (document.body.clientWidth < 1024) {
        this.isNeedToPushDown = true;
      } else {
        this.isNeedToPushDown = false;
      }
    },
  },
  setup() {
    return { ...useSelectedData(), ...useJsonData(), ...useDataContext() };
  },
};
</script>

<style scoped>
.pushdown {
  margin-bottom: 10%;
}

@media screen and (max-width: 410px) {
  .pushdown {
    margin-bottom: 15%;
  }
}
</style>
